

import React, { useState, useEffect } from 'react';
import DispositionBlock from './sections/dispositions';
import StartSession from './startSession';
import { useTimer } from './callTimer';
import { useSelector, useDispatch } from 'react-redux';
import { captureCallError, setRingState, setStartSession } from '../../../features/callSlice';
import { setHasTriggeredMicModal, setMicPermissionModalLocked } from '../../../features/callPermissionErrorSlice';

function Dial({apptSet, fetchQueue, jumpIntoQueue, handleLeadData, addTag, device, from, theCall, handlCallAccepted, makeDial, dialAmount, currentLead,incrementQueue,canMessageTCPA}) {
    const [currentDial, setCurrentDial] = useState(1);
    const [disposition, setDisposition] = useState(null);
    const startSession=useSelector((state) => state.call.sessionStarted);
    const leadsAlldata = useSelector((state) => state.leadAllDataInfo?.leadsAllInfoData);
const micPermissionModalLocked = useSelector(state => state.micpermissions.micPermissionModalLocked);

    const [run, setRun] = useState(null);
    const dispatch = useDispatch();
    const { seconds, clearTimer, resetTimer } = useTimer(null, () => {
        device.disconnectAll();
        setTimeout(() => {
            if(currentDial < dialAmount){
                resetTimer(16);
                makeDial(toCall);
                setCurrentDial(currentDial+1);
            }
            else if(currentDial === dialAmount){
                setCurrentDial(currentDial+1);
                makeDial(toCall);
                clearTimer();
            }
            else{
                clearTimer();
            }
        }, 2500);
    });

    const [click, setClick] = useState(false);

    function getFirstNumber(number1, number2, number3) {
        if (number1 !== null && number1 !== undefined) {
            return number1;
        }
        if (number2 !== null && number2 !== undefined) {
            return number2;
        }
        if (number3 !== null && number3 !== undefined) {
            return number3;
        }
        return null;
    }
    const toCall=getFirstNumber(leadsAlldata.borrower_cell,leadsAlldata.borrower_home,leadsAlldata.borrower_work);
    useEffect(() => {
        if(leadsAlldata && startSession){
            if(!click){
                if(dialAmount > 1){
                    resetTimer(18);
                    setCurrentDial(2);
                    dispatch(setRingState('Ringing...'));
                    makeDial(toCall);
                }
                else{
                    dispatch(setRingState('Ringing...'));
                    makeDial(toCall);
                }
            }
        }

        return () => {
          // Do something when the component unmounts
        };
    }, [startSession, leadsAlldata.lead_id]);

    useEffect(() => {

        if(theCall){
            theCall.on("accept", () => {
                dispatch(setRingState('Connected'));
                clearTimer();
            });
            theCall.on("disconnect", () => {
                dispatch(setRingState('Disconnected'));
                clearTimer();
            });
            theCall.on('error', (error) => {
                // console.error('Call blocked by the carrier.', error);
                dispatch(captureCallError({
                    errorCode: error.code,
                    errorMessage: error.explanation ?? error.message,
                    errorSolutions: error.solutions
                }))

            });
        }
    }, [theCall]);

    const handleStartSession=async ()=>{
        try{
            await navigator.mediaDevices.getUserMedia({ audio: true });
            dispatch(setStartSession(true));
            setRun(true);
            dispatch(setMicPermissionModalLocked(false));
            dispatch(setHasTriggeredMicModal(false));
        }catch (err) {
            dispatch(setStartSession(false));
            dispatch(setMicPermissionModalLocked(true));
            dispatch(setHasTriggeredMicModal(true));
        }

    }
    const clickToDial=()=>{
        dispatch(setStartSession(true));
        setRun(true)
        setClick(true);
    }

    return (
        <>
            {startSession===false && !micPermissionModalLocked && (
                <StartSession clickToDial={clickToDial} handleStartSession={handleStartSession} />
            )}
            <div className="dispositionHolder">
                <DispositionBlock canMessageTCPA={canMessageTCPA} apptSet={apptSet} fetchQueue={fetchQueue} jumpIntoQueue={jumpIntoQueue} type={leadsAlldata.parent_status} setDisposition={setDisposition} handleLeadData={handleLeadData} addTag={addTag} setCurrentDial={setCurrentDial} tags={leadsAlldata.tag_ids} from={from} theCall={theCall} incrementQueue={incrementQueue} queuePos={leadsAlldata.queuePos} click={click} leadId={leadsAlldata.lead_id}  handlCallAccepted={handlCallAccepted} />
            </div>
        </>
    );
}

export default Dial;
//